window.ChatWidget = function () {

    var self = this;
    self.conversationGoing = false;
    function init(context) {
        var parsedContext = parseContext(context);
        self.firstName = parsedContext.firstName;
        self.lastName = parsedContext.lastName;
        self.phone = parsedContext.phone;
        self.email = parsedContext.email;
        self.referenceNumber = context.referenceNumber;
        self.sEvent = context.trackingInfo.sEvent;
        self.sEvar = context.trackingInfo.sEvar;
        self.sEvarVal = context.trackingInfo.sEvarVal;
        self.pageName = parsedContext.pageName;
        self.policyID = parsedContext.policyID;
        self.policyNumber = parsedContext.policyNumber;
        self.area = context.area;
        self.queue = context.queue;
        self.hubUrl = context.hubUrl;

        Genesys("subscribe", "CobrowseService.sessionStarted", e => {
            Engagement.Track({
                EngagementType: 'Cobrowse',
                Area: self.area,
                PageName: self.pageName,
                Initiated: true,
                UserAgent: navigator.userAgent,
                PolicyID: self.policyID,
                PolicyNumber: self.policyNumber
            });
        });

        Genesys("subscribe", "MessagingService.conversationCleared", function ({ data }) {
            self.conversationGoing = false;
            document.getElementById("custom-launcher").style.display = "none";
            $("#genesys-messenger").hide();
        });

        Genesys("subscribe", "Messenger.closed", function () {
            if (window.innerWidth <= 768) {
                Genesys("command", "Launcher.hide");
                document.getElementById("custom-launcher").style.display = self.conversationGoing
                    ? "flex"
                    : "none";
            }
        });

        Genesys("subscribe", "Messenger.opened", function () {
            self.conversationGoing = true;
            document.getElementById("custom-launcher").style.display = "none";
            $("#genesys-messenger").show();

            Engagement.Track({
                EngagementType: 'Chat',
                Area: self.area,
                PageName: self.pageName,
                Initiated: true,
                UserAgent: navigator.userAgent,
                PolicyID: self.policyID,
                PolicyNumber: self.policyNumber
            });
        });

        Genesys("subscribe", "Launcher.visible", function () {
            if (window.innerWidth <= 768) {
                if (!self.launcherShownInitially) {
                    document.getElementById("custom-launcher").style.display = "flex";
                    Genesys("command", "Launcher.hide");
                }
                self.conversationGoing = true;
            }
        });
    }

    function startChatSession() {
        if (window.Genesys) {

            window.Genesys("command", "Database.set", {
                messaging: {
                    customAttributes: {
                        ReferenceNumber: self.referenceNumber, // Shaun requested uppercase "ReferenceNumber"
                        policyNumber: self.policyNumber,
                        firstName: self.firstName,
                        lastName: self.lastName,
                        email: self.email,
                        phone: self.phone,
                        name: `${self.firstName} ${self.lastName}`,
                        queue: self.queue,
                        pageName: self.pageName,
                        policyID: self.policyID,
                        hubUrl: self.hubUrl,
                        url: (typeof window !== "undefined" && window.location) ? window.location.href : '',
                        source: self.area
                    }
                }
            },
                function () {
                    setTimeout(() => {
                        window.Genesys("command", "Messenger.open", {},
                            function (o) {
                                window.Genesys("command", "Launcher.show");
                            },  // if resolved
                            function (o) {    // if rejected
                                window.Genesys("command", "Messenger.close");
                            }
                        );
                    }, 500);
                });
        }
    }
    function parseContext(context) {
        var firstName, lastName, email, phone, pageName, policyID, policyNumber;

        if (typeof context.getUsername === "function") {
            let username = context.getUsername();
            if (username) {
                let usernameParts = username.split(' ');
                firstName = username.split(' ')[0];
                if (usernameParts.length > 1) {
                    lastName = usernameParts.slice(1).join(' ');
                }
            }
        }

        if (typeof context.getEmail === "function") {
            email = context.getEmail();
        }

        if (typeof context.getPhone === "function") {
            phone = context.getPhone();
        }

        if (typeof context.getPageAndPolicyContext === "function") {
            var pageContext = getPageAndPolicyContext();
            pageName = pageContext.pageName;
            policyID = pageContext.policyID;
            policyNumber = pageContext.policyNumber;
        }
        else {
            if (!pageName) {
                var match = window.location.href.match(/[^\/]+(?=\/?$)/);
                pageName = (match ? match[0] : "").replace('#', '');
            } else if (options.sEvarVal != undefined && options.sEvarVal == "Chat SS:Popup" && pageName.toLowerCase().indexOf("loading") > -1) {
                pageName = $("#ui-dialog-title-pep-dialog").html();
            }
        }

        return {
            firstName: firstName,
            lastName: lastName,
            email: email,
            phone: phone,
            pageName: pageName,
            policyID: policyID,
            policyNumber: policyNumber
        };
    }

    return {
        Init: init,
        StartChatSession: startChatSession,
    }
}();